import { Injectable, Injector } from '@angular/core';
import { MarsHttpDataService } from 'app/mars/services/mars-http-data.service';
import { Observable } from 'rxjs';

@Injectable()
export class MarsQuestionsStatsService extends MarsHttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/admin/groupQuestions');
  }

  getGroupQuestionsStats(options?: any): Observable<any> {
    // const url = this.baseUrl +  '/stats?groupId=' + options.groupId;
    const url = `${this.baseUrl}/stats`;
    return this.fetchRequest(url, options);
  }
}
